import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { useDataModel } from '@thd-nucleus/data-sources';
import { useMemo } from 'react';
import { isSsr } from '../utils/general';
export var useFetchProTiers = function () {
    var _a = useThdCustomer(), svocID = _a.svocID, userID = _a.userID, isB2BCustomer = _a.isB2BCustomer;
    var response = useDataModel('homepageWelcomeCard', {
        variables: {
            customerAccountId: svocID || '',
            userId: userID || '',
            channelId: 1,
        },
        skip: !isSsr && (!isB2BCustomer || !userID),
        ssr: false,
        context: { withAuth: true },
    });
    return useMemo(function () {
        return response;
    }, [response === null || response === void 0 ? void 0 : response.data]);
};
export var useLoyaltyMembershipDetails = function () {
    var _a = useThdCustomer(), svocID = _a.svocID, userID = _a.userID, isB2BCustomer = _a.isB2BCustomer;
    var response = useDataModel('loyaltyMembershipDetails', {
        variables: {
            customerAccountId: svocID || '',
            userId: userID || '',
            channelId: 1,
        },
        skip: !isSsr && (!isB2BCustomer || !userID),
        ssr: false,
        context: { withAuth: true },
    });
    return useMemo(function () {
        return response;
    }, [response === null || response === void 0 ? void 0 : response.data]);
};
